
import { TYPE } from 'network/network_api'
import { REQUEST_TYPE } from 'network/net'
import { canOnlyGo } from './network/network_api.es6';

export default function(
    parent,
    $state,
)
{
    const space = parent.child( "balance" );

    const $balance = parent.s( "balance" );
    parent.s( "net" )
        .map( net => net.balance )
        .to( $balance );
    //собственно вот и пытаюсь сделать так чтобы не было такого двойного начисления после предсказания:
    //TODO: there is a potential time gap when balance polling request may succeed before spin initiation will and so will overwrite client-side credits prediction:
    parent.s( "balance_poll" )
        .with( parent.s( "pending" ), ( poll, pending ) => ({ poll, pending }) )
        .filter( ({ pending }) => pending === undefined )
        .map( ({ poll }) => poll )
        .to( $balance )

    const $clientCredits = $balance.map( balance => balance.gameable );
    $clientCredits.subscribe( space.s( "credits" ) );
    space.s( "creditsChange" )
        .withLatestFrom( $clientCredits, ( change, credits ) => credits + change )
        .subscribe( space.s( "credits" ) );

    $balance
        .map( balance => balance.gameable_money )
        .to( space.s( "money" ) )
    space.s( "creditsChange" )
        .with( $balance, ( change, balance ) => ({ change, balance }) )
        .map( ({ change, balance }) => balance.gameable_money + ( change * balance.credit_price ) )
        .to( space.s( "money" ) )
    
    $balance
        .filter( balance => window.self !== window.top && ! balance.demo )
        .on( balance => window.top.postMessage( "balance_update: " + balance.gameable_money, "*" ) )

    //when any previous win flow initiation completes or interrupts:
    const winFlowDone = (interrupts = false) => space.s( "winFlowComplete" ).next(interrupts);
    var tween = undefined;
    const $winFlow = space.s( "winFlow", 0 );
    const $winTarget = space.s( "winTarget", 0 );
    const interrupt = winTarget => {
        if ( tween )
        {
            tween.stop();
            tween = undefined;
        }
        $winFlow.next( winTarget );
    };
    space.s( "winFlowUp" )
        .desc( "request to flow up another portion of winnings, any previous win flow process will terminate and commit to the final value" )
        //current target win value current process or win flow will eventually come up to:
        .withLatestFrom( $winTarget, ( up, value ) => ({ up, value }) )
        .subscribe( ({ up, value }) =>
        {
            interrupt( value );
            $winTarget.next( value + up );

            if (up) {
                const win = {value};
                const to = value + up;
                const time = 1000 * Math.log(to - value);
                tween = space.tween(win)
                    .to({value: to}, time)
                    .onUpdate(() => $winFlow.next(win.value | 0))
                    .onComplete(winFlowDone)
                    .onStop(() => {
                        winFlowDone(true)
                    })
                    .start();
            }
        } );

    //recover previous winnings within current scenario and allow animations to flow it up:
    $state
        .take( 1 )
        .subscribe( state =>
        {
            const winTarget = state.server.totalWinInCoins - state.server.spinWinInCoins;
            $winTarget.next( winTarget );
            $winFlow.next( winTarget );
        } );
    //replicate server-side win on specific states to both restore state on those states and mute any flow errors which may happen on previous state:
    $state
        .filter( state => _.includes(
            [
                TYPE.RISK_MAIN,
                TYPE.RISK_RESULT,
                TYPE.FINISH,
                TYPE.FINAL,
            ],
            state.type
        ) )
        .name( space, "replicate" )
        .subscribe( state =>
        {
            $winTarget.next( state.server.totalWinInCoins );
            interrupt( state.server.totalWinInCoins );
        } );
    
    //прерывать натекание когда отправляется запрос забора выигрыша, а не когда уже приходит ответ:
    $state
        .any( parent.s( 'collecting' ), ( state, collecting ) => ({ state, collecting }) )
        .filter( ({ state, collecting }) =>
            state.type == TYPE.REGULAR
            &&
            collecting
        )
        .do( ({ state }) => {
            $winTarget.next( 0 )
            interrupt( 0 )
            space.s( "creditsChange" ).next( state.server.totalWinInCoins )
        } )
        .filter( ({ state }) => state.server.totalWinInCoins )
        .to( parent.s( 'slot:money_up_sound' ) )

    return space;
}



// WEBPACK FOOTER //
// ./src/library/balance.es6